import cs from 'classnames';

import MainNavigation from '../../components/MainNavigation';
import NavFooter from '../../components/NavFooter';
import useNavData from '../../hooks/useNavData';

import { StyledNavigationContainer } from '../../styles';

const NavigationContainer = () => {
  const {
    isCollapsed,
    navConfig,
    onTransitionEnd,
    toggleNavigation,
    transitionInProgress,
    autoCollapse,
  } = useNavData();

  return (
    <StyledNavigationContainer
      data-testid={`main-navigation-container-${isCollapsed ? 'collapsed' : 'expanded'}`}
      className={cs({
        'expanded-state': !isCollapsed,
        'collapsed-state': isCollapsed,
        'transition-active': transitionInProgress,
      })}
    >
      <MainNavigation
        isExpanded={!isCollapsed}
        navConfig={navConfig}
        onTransitionEnd={onTransitionEnd}
      />
      <NavFooter
        toggleNavigation={toggleNavigation}
        autoCollapse={autoCollapse}
        isCollapsed={isCollapsed}
      />
    </StyledNavigationContainer>
  );
};

export default NavigationContainer;
